import EditOrganizationTemplate from './editOrganization.html';
import EditOrganizationDataProviderModule from './editOrganizationDataProvider.js';
import ComponentsModule from './components/components.js';
import TabsModule from './tabs/tabs.js';

export default angular
  .module('main.organizations.edit', [
    EditOrganizationDataProviderModule,
    ComponentsModule,
    TabsModule,
  ])
  .config(EditOrganizationRouter)
  .name;

function EditOrganizationRouter($urlRouterProvider, $stateProvider) {
  $stateProvider
    .state('main.organizations.edit', {
      url: `/edit/:organizationId?:tab?`,
      template: EditOrganizationTemplate,
      controller: EditOrganizationController,
      params: {
        organization: null,
        organizationId: {
          squash: true,
          value: null
        }
      }
    });
}

function EditOrganizationController(
  $scope,
  $rootScope,
  $q,
  $filter,
  $state,
  EditOrganizationDataProvider,
  utils,
  ToastsService,
  PermissionsService) {

  const $t = $filter('translate');
  const isAdminsEditor = PermissionsService.canIManageOrganizationAdmins();
  const isBillingAvailable = PermissionsService.canIViewBills();

  // NOTE dirty hack for fast injecting ready-to-use data provider to child components
  EditOrganizationDataProvider.instance = new EditOrganizationDataProvider();
  let dataProvider = EditOrganizationDataProvider.instance;
  $scope.dataProvider = dataProvider;

  // #region Navigation Tabs
  $scope.tabs = [
    {
      id: 'contacts',
      name: $t('orgs.new.contacts.title'),
      icon: 'far fa-address-card'
    },
    {
      id: 'info',
      name: $t('orgs.edit.edit.title'),
      icon: 'far fa-pencil',
      hidden: true,
      silent: true
    },
    {
      id: 'settings',
      name: $t('orgs.new.settings.title'),
      icon: 'far fa-cog'
    },
    {
      id: 'objects',
      name: $t('orgs.edit.objects.title'),
      icon: 'far fa-cogs',
      hidden: true
    },
    {
      id: 'admins',
      name: $t('orgs.edit.admins.title'),
      icon: 'iotr fa-user-admin',
      hidden: !isAdminsEditor
    },
    {
      id: 'billing',
      name: $t('orgs.edit.billing.title'),
      icon: 'far fa-wallet',
      hidden: !isBillingAvailable
    },
    {
      id: 'billingPlans',
      name: $t('orgs.edit.billing.plans'),
      icon: 'far fa-coins',
      hidden: true
    },
    {
      id: 'reports',
      name: $t('orgs.new.reports.title'),
      icon: 'far fa-chart-line',
      hidden: !isAdminsEditor
    },
    {
      id: 'appearance',
      name: $t('orgs.new.appearance.title'),
      icon: 'far fa-palette'
    },
    {
      id: 'templates',
      name: $t('settings.title'),
      icon: 'far fa-swatchbook'
    },
    {
      id: 'bots',
      name: $t('bots.bots'),
      icon: 'iotr fa-bot',
    }
  ];
  // #endregion

  angular.extend($scope, {
    onEditOrganizationButtonClick: onEditOrganizationButtonClick,
    copyToClipboard: $rootScope.copyToClipboard,
  });

  init();

  function init() {
    $scope.loading = true;

    $q.all([
      checkPermissions(),
      dataProvider.mainResourceGroup.init(),
    ])
      .then(() => {
        // Set default tab, only if main resources loaded successfully
        dataProvider.activeTab = $state.params.tab || 'contacts';
      }, (err) => {
        if (err?.resultCode === 7) { // Access denied
          // TODO: describe error
          $scope.accessDeniedError = true;
          $scope.isError = true;
          $scope.errorTitle = $t('locations.edit.errors.accessDenied.title');
          $scope.errorDesc = $t('locations.edit.errors.accessDenied.desc');
          return $q.reject();
        } else if (err?.resultCode === 8) { // Object not found
          // TODO: describe error
          $scope.notFoundError = true;
          $scope.isError = true;
          $scope.errorTitle = $t('locations.edit.errors.notFound.title');
          $scope.errorDesc = $t('locations.edit.errors.notFound.desc');
          return $q.reject();
        }
        return $q.reject(err);
      })
      .then(() => {
        $scope.loading = false;
      }, (err) => {
        $scope.loading = false;
        if (err) {
          utils.handleApiError(err);
        }
        dataProvider.goBack();
      });

    $scope.$watch('dataProvider.organizationResource.value', () => {
      $scope.organizationAddress = getOrganizationAddress();
    }, true);

    $scope.$on('$destroy', () => {
      dataProvider.destroy();
      EditOrganizationDataProvider.instance = undefined;
    });
  }

  /**
   * Check if we have enough permissions to see this organization
   * @return {Promise}
   */
  function checkPermissions() {
    return dataProvider.canIEditOrganizationResource.init()
      .then((allowed) => {
        if (allowed === false) {
          ToastsService.error($t('orgs.wrongPermissions.title'), $t('orgs.wrongPermissions.desc'));
          dataProvider.goBack();
        }
      });
  }

  /**
   * Get well-formatted organization address
   * @return {string|undefined}
   */
  function getOrganizationAddress() {
    if (!dataProvider.organizationResource.value) {
      return;
    }
    let address = utils.generateAddress(dataProvider.organizationResource.value);
    if (!address) {
      return $t('common.unknown-address');
    }
    return address;
  }

  function onEditOrganizationButtonClick() {
    if ($scope.dataProvider.activeTab === 'info') {
      $scope.dataProvider.activeTab = $scope.dataProvider.previousTab || 'contacts';
      return;
    }
    $scope.dataProvider.activeTab = 'info';
  }

}
